// Canonical list of optional fields shown inline on task cards/chips across
// the non-table views (list, board, calendar, timeline, gallery). Title is
// never optional; the checkbox and drag handle are part of the view chrome.
//
// Each field has a stable key used in view.config.visible_fields and a
// translation key for the display-fields picker label.
export const BUILT_IN_VIEW_FIELDS = [
  { key: 'description', i18n: 'view_fields.description' },
  { key: 'status',      i18n: 'view_fields.status'      },
  { key: 'priority',    i18n: 'view_fields.priority'    },
  { key: 'due_date',    i18n: 'view_fields.due_date'    },
  { key: 'start_date',  i18n: 'view_fields.start_date'  },
  { key: 'duration',    i18n: 'view_fields.duration'    },
  { key: 'assignee',    i18n: 'view_fields.assignee'    },
  { key: 'project',     i18n: 'view_fields.project'     },
  { key: 'labels',      i18n: 'view_fields.labels'      },
  { key: 'attachments', i18n: 'view_fields.attachments' },
];

// Per-type default field visibility - chosen to match what each view rendered
// before this feature shipped, so existing users see no visual change until
// they actively toggle something.
export const DEFAULT_FIELDS_BY_TYPE = {
  list:     ['priority', 'due_date', 'duration', 'project', 'attachments'],
  board:    ['description', 'priority', 'due_date', 'duration', 'project', 'attachments'],
  calendar: ['priority', 'duration'],
  timeline: ['priority', 'duration'],
  gallery:  ['description', 'priority', 'due_date', 'duration', 'project'],
};

export function getDefaultFields(viewType) {
  return DEFAULT_FIELDS_BY_TYPE[viewType] || [];
}

export function resolveVisibleFields(view, customFieldDefs = []) {
  const explicit = view?.config?.visible_fields;
  if (Array.isArray(explicit)) return explicit;
  // No explicit config → fall back to per-type defaults + all custom fields
  // (custom fields default to visible; user can hide them).
  const type = view?.type;
  const defaults = getDefaultFields(type);
  return [...defaults, ...customFieldDefs.map(d => `cf_${d.id}`)];
}

export function isFieldVisible(view, fieldKey, customFieldDefs = []) {
  return resolveVisibleFields(view, customFieldDefs).includes(fieldKey);
}
